import gql from 'graphql-tag';

const AUTHENTICATE_WITH_NYLAS = gql`
  mutation AuthenticateWithNylas($params: AuthenticateWithNylasParams!) {
    authenticateWithNylas(params: $params)
  }
`;

export default AUTHENTICATE_WITH_NYLAS;
